import React from "react";
import { Link, useLocation } from "react-router-dom";

// Every print view is a routed page whose path contains "print"
// (e.g. /print-rent, /print-wakel, /text-print). Show a floating
// "return to home" shortcut on those pages while on screen; the
// `no-print` class hides it from the printed output.
const isPrintPage = (pathname) => pathname.toLowerCase().includes("print");

const HomeButton = () => {
  const location = useLocation();

  if (!isPrintPage(location.pathname)) return null;

  return (
    <Link
      to="/"
      className="no-print"
      title="گەڕانەوە بۆ لاپەڕەی سەرەکی"
      style={{
        position: "fixed",
        top: "10px",
        left: "10px",
        zIndex: 9999,
        backgroundColor: "#0f5279",
        color: "#fff",
        padding: "8px 16px",
        borderRadius: "6px",
        textDecoration: "none",
        fontWeight: "bold",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3)"
      }}
    >
      🏠 گەڕانەوە بۆ سەرەتا
    </Link>
  );
};

export default HomeButton;
